export interface LessonGet {
  type: string;
  lesson_id: string;
}

export interface LessonPublishUnpublish {
  lesson_id: string;
  status: number;
}

export interface Lesson {
  type?: string;
  country: string;
  category: string;
  topic: string;
  description: string;
  points: number;
  subjects: Array<{
    id: string;
    subTopic: string;
    description: string;
    date: string;
    time: string;
  }> | null;
  loading: boolean;
}

export interface LessonPayload {
  country_id?: { value: string | number | null; error: string | null };
  category_id?: { value: string | number | null; error: string | null };
  topic?: { value: string; error: string | null };
  description?: { value: string; error: string | null };
  lesson_points?: { value: string | number | null; error: string | null };
  point_per_lesson?: { value: string | number | null; error: string | null };
  lesson_type?: { value: string | number; error: string | null };
  lesson_mode?: { value: string | number; error: string | null };
  time_slot?: ITimeSlot;
  lessons: SubLesson[];
}

export interface ITimeSlot {
  value: any;
  error: string | null
}

export interface SubLesson {
  id?: string;
  topic?: { value: string; error: string | null };
  description?: { value: string; error: string | null };
  time_slot?: { value: any; error: string | null };
}

export enum LessonTypes {
  Individual = 1,
  Group = 2,
}

export enum LessonMode {
  SINGLE = "Single",
  PACK = "Pack",
}

export enum LessonStatus {
  UNPUBLISH = 0,
  PUBLISH = 1,
}
